// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"ae95f0f7","53":"eb98caa5","63":"e68018dc","154":"7fa02564","324":"85d246cb","453":"9a1ac91d","634":"a0b05190","713":"52265f94","767":"3074c4d5"}[chunkId] + ".chunk.js";
};